import React from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { pipe, defaultTo, toLower } from 'ramda'
import * as dayjs from 'dayjs'
import frLocale from 'dayjs/locale/fr-ca'

const localeContext = React.createContext()
const { Provider, Consumer } = localeContext

const Locale = ({ children, cookies }) => {
  const locale = {
    lang: pipe(defaultTo('en'), toLower)(cookies.cookies.lang),
    prov: pipe(defaultTo('bc'), toLower)(cookies.cookies.prov)
  }
  dayjs.locale(locale.lang !== 'en' ? frLocale : 'en')
  return <Provider value={locale}>{children}</Provider>
}

const LocaleProvider = withCookies(Locale)

Locale.propTypes = {
  children: PropTypes.node.isRequired,
  cookies: PropTypes.object.isRequired
}

export default localeContext

export { LocaleProvider, Consumer as LocaleConsumer }
